import React, { useMemo, useState } from 'react';
import BubbleCommon from '@op/components/BubbleCommon';
import { ConfigProvider, Pagination, Table } from 'tea-component';
import { metricsMap, tipsMap } from '../../../constants';
import UserInfoItem from '@op/components/Snippets/UserInfoItem';
import ChannelLabel from '@op/components/ChannelLabel';
import HoverSortCommon from '@op/components/HoverSortCommon';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { getChartsShowCount } from '@op/utils';
import { getLocale, useIntl } from 'umi';
import { getTeaLocale } from '@/pages/home/utils/lang';

const { scrollable, sortable, autotip } = Table.addons;
/**
 * TODO: 其他系统使用
 * @param param0
 * @returns
 */
export default function ChannelsShareTable({
  sort,
  sortChange,
  metric,
  tableList,
  total,
  defaultPageSize,
  apiError,
  loading,
  totalColumn,
}: any) {
  const [pageInfo, setPageInfo] = useState({ pageSize: 10, pageIndex: 1 });
  const { formatMessage } = useIntl();
  // sort变化排序做一次缓存，分页就不用再排序了
  const sortTableRecord = useMemo(() => {
    if (!tableList) {
      return [];
    }
    return [...tableList.sort(sortable.comparer([sort]))];
  }, [sort, tableList]);

  const recordList = useMemo(() => {
    const { pageIndex, pageSize } = pageInfo;
    const start = (pageIndex - 1) * pageSize;
    const end = pageIndex * pageSize;
    let list: any[] = sortTableRecord.slice(start, end);
    if (list.length === 0) {
      return [];
    }
    list.unshift(totalColumn);
    return list;
  }, [sortTableRecord, pageInfo, total]);

  const locale = getTeaLocale(getLocale());

  return (
    <ConfigProvider locale={locale}>
      <Table
        className="channels-share-table-wrapper"
        recordKey="user_id"
        bordered="all"
        records={recordList}
        columns={[
          {
            key: 'Channel',
            header: (
              <div className="channelsshare-card-table-title">
                {formatMessage({ id: 'Channel' })}
              </div>
            ),
            width: 400,
            align: 'left',
            render: ({ channel, user_name, logo, channel_url }: any) => {
              return user_name === 'Total' ? (
                formatMessage({ id: 'Total' })
              ) : (
                <UserInfoItem
                  onClick={() => window.open(channel_url, '_blank')}
                  isLink
                  icon={logo}
                  name={user_name}
                >
                  {(className) => (
                    <div className={className}>
                      <ChannelLabel
                        className="channelsshare-card-table-icon"
                        channel_name={channel}
                        showText={false}
                      />
                    </div>
                  )}
                </UserInfoItem>
              );
            },
          },
          {
            key: metric,
            align: 'left',
            header: (
              <div className="table-header channelsshare-card-table-header">
                <HoverSortCommon
                  sort={sort}
                  sortKey={metric}
                  sortChange={sortChange}
                  sortOptions={[
                    { text: metricsMap[metric], value: 'value' },
                    { text: metricsMap[metric] + '%', value: 'ration_percent' },
                  ]}
                >
                  <BubbleCommon
                    showIcon={false}
                    placement="top"
                    tipsMap={tipsMap[metric]}
                  >
                    {formatMessage({ id: metricsMap[metric] })}
                  </BubbleCommon>
                </HoverSortCommon>
              </div>
            ),
            render: ({ ration_percent, value }: any) => {
              const newValue = Number(value?.toFixed(2));
              return (
                <div className="channelsshare-card-table-row">
                  <PercentageItem percentage={ration_percent}>
                    {(element) => (
                      <>
                        {getChartsShowCount(newValue)} {element}
                      </>
                    )}
                  </PercentageItem>
                </div>
              );
            },
          },
        ]}
        addons={[
          scrollable({ scrollToTopOnChange: true }),
          autotip({
            isError: apiError,
            isLoading: loading,
          }),
        ]}
      />

      <Pagination
        pageSizeOptions={[defaultPageSize, 15, 20]}
        onPagingChange={(query) => {
          setPageInfo({
            pageIndex: query.pageIndex || 1,
            pageSize: query.pageSize || defaultPageSize,
          });
        }}
        pageSize={pageInfo.pageSize}
        pageIndex={pageInfo.pageIndex}
        recordCount={total}
        stateTextVisible={true}
        pageSizeVisible={total > defaultPageSize}
        pageIndexVisible={total > defaultPageSize}
        jumpVisible={total > defaultPageSize}
        endJumpVisible={total > defaultPageSize}
      />
    </ConfigProvider>
  );
}
